import React, { forwardRef } from 'react';
import classNames from 'classnames';
var IconWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      style = props.style,
      children = props.children,
      prefixCls = props.prefixCls;
  var iconWrapperCls = classNames("".concat(prefixCls, "-icon"), className);
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    className: iconWrapperCls,
    style: style
  }, children);
});
export default IconWrapper;